import classes from './sidebars.module.css';

export type DetailRowProps = {
  label: string;
  value: string | undefined | null;
};

const DetailRow = ({ label, value }: DetailRowProps) => (
  <div className={classes.detailRow}>
    <div className={classes.detailLabel}>{label}:</div>
    <div className={classes.detailValue}>{value ?? ''}</div>
  </div>
);

export default DetailRow;
